export const unsavedChangesModalCopy = {
  header: '',
  description: '',
  confirmBtnText: '',
  cancelBtnText: '',
};
